<template lang="pug">
    div.main-layout-top-right
        cart-button-control
        div.main-layout-top-right__user(@click='logout')
            svg-icon(iconId='logout')
            span Log Out
</template>

<script>
export default {
    name: 'main-layout-top-right',

    methods: {
        logout() {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'login-page' })
        },
    },
}
</script>
